export default "__VITE_ASSET__DAtHGrd9__"